export default __webpack_public_path__ + "static/media/indirect-sales.d4142f5c.svg";